import styled from 'styled-components';

export const StripDiv = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	gap: 0;
	padding-left:.35rem;
	label{
		font-size: 0.813rem;
		color: var(--subHeadingColor);
		transition-delay: 1s;
		font-family: Inter;
		position:relative;
	}
`;
export const LabelInfo = styled.div`
		font-size: 0.813rem;
		color: var(--subHeadingColor);
		transition-delay: 1s;
		font-family: Inter;
		font-weight:600;
		position:relative;
		padding-right: .15rem;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		gap: .5rem;
		min-height:27px;
		// border-right: 1px solid #e4e4e4;
		padding-right: .65rem;
}
`;
export const ModeToggle = styled.div`{
	display: flex;
	margin-right: 10px;

	.switchButton .button{
	width: 35px;
	height: 20px;
}
		
.checkbox {
	position: relative;
	width: 100%;
	height: 100%;
	padding: 0;
	margin: 0;
	opacity: 0;
	cursor: pointer;
	z-index: 3;

	&:disabled{
		cursor: not-allowed;
	}
}

.knobs {
	z-index: 2;
	background: var(--toggleTrackColor);
	border-radius: 48px;
	border: 1.5px solid var(--toggleTrackColor);
}

.layer {
	width: 100%;
	transition: 0.3s ease all;
	z-index: 1;
}

#button-13 .knobs:before,
#button-13 .knobs:after,
#button-13 .knobs span {
	position: absolute;
	top: 1.5px;
	width:13px;
	height: 12px;
	font-size: 10px;
	font-weight: bold;
	text-align: center;
	line-height: 1;
	border-radius: 2px;
	transition: 0.3s ease all;
}
#button-13 .knobs span {
	top:1px
}

#button-13 .knobs:before,
#button-13 .knobs:after {
	color: #4e4e4e;
	z-index: 1;
}

#button-13 .knobs:before {
	content: "";
	left: 7px;
	visibility: hidden;
	display: none;
	top: 5px;
}
#button-13 .knobs:after{
content: "";
}

#button-13 .knobs span {
	width: 16px;
	height: 16px;
	left: 2px;
	background-color: var(--toggleThumbColor);
	z-index: 2;
	border-radius: 100%;
}

#button-13 .checkbox:checked + .knobs span {
	left: 15px;
	background-color: var(--toggleThumbColor);
}
#button-13 .checkbox:checked + .knobs:before {
	content: '';
	visibility: visible;
	display: block;
	color: #fff;
}

#button-13 .checkbox:checked + .knobs {
 background-color: var(--primary);
 border: 1.5px solid var(--primary);
}
#button-13 .checkbox:checked + .knobs:after {
	visibility: hidden;
	display: none;
}

#button-13 .checkbox~ .layer {
	background-color: var(--defaultBgColor);
	border-radius:48px ;
}
`;

export const EditObstructionOptions = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	padding-left: 6px;
	gap: 5px;
	

	span{
		color: var(--textTitleColor);
		font-size: 0.813rem;
		white-space: nowrap;
		font-family: Inter;
		font-weight: 600;
	}
		
`;

export const BtnWrap = styled.div`
	display: flex;
	&.shapeBtn-wrap{
		padding-right:4px;
		margin-right:4px;
		height:30px;
		align-items:center;
		border-right: 1px solid var(--borderColor);
	}
`;

export const ShapeBtn = styled.label`
	display: flex;
	align-items: center;
	cursor: pointer;
	border: 0px;
	border-left: 0px;
	border-right: 1px dashed
	 var(--borderLightColor);
	color: var(--labelValueColor);
	font-size: 0.938rem;
	padding: 0px .5rem;
	background: var(--modalBgColor);
	height: 20px;
	width: auto;
	border-radius: 0px;
	min-width: 30px;

	@media (max-width: 540px) {
		padding: 0px .375rem;
	}

	&#multiple-panel{
		padding-left: 0.25rem;
	}
	input {
		position: absolute;
		opacity: 0;
		cursor: pointer;
		height: 0;
		width: 0;
	}

`;

export const PointsLabel = styled.label`
	display: flex;
  align-items: center;
  cursor: pointer;
  color: var(--textColor);
  font-size: 13px;
  font-weight: 500;
	line-height: 16px;
  padding: 0;
  background: transparent;
  height: auto;

  span {
    color: var(--subHeadingColor);
    font-weight: 500;
  }
`;

// export const CheckToggle = styled.div`
//   display: inline-flex;
//   background: #eef2f7;
//   border-radius: 999px;
//   padding: 3px 4px 3px 4px;
//   gap: 0px;
// 	border: 1px solid #e3e3e3;
// 	box-shadow: none;
// 	overflow: hidden;

//   .check-control {
//     cursor: pointer;
// 		display: flex;
// 		align-items: center;
//   }

//   .check-control input {
//     display: none;
//   }

//   .check-mark {
// 		padding: 1px 12px;
//     font-size: 12px;
//     font-weight: 500;
//     line-height: 24px;
//     color: #4a525a;
//     border-radius: 999px;
//     transition: 
//       background-color 0.25s ease,
//       color 0.25s ease,
//       box-shadow 0.25s ease;

//     backface-visibility: hidden;
//   }

//   /* ACTIVE */
//   .check-control input:checked + .check-mark {
//     background-color: #003cff;
//     color: #fff;
//     box-shadow: 0 2px 6px rgba(0, 60, 255, 0.25);
//   }

//   /* DISABLED */
//   .check-control input:disabled + .check-mark {
//     opacity: 0.6;
//     cursor: not-allowed;
//   }
// `;

export const CheckToggle = styled.div`
  position: relative;
  display: inline-flex;
  background: var(--toggleGroupBgColor);
  border-radius: 999px;
  padding: 3px 4px;
  border: 1px solid var(--toggleGroupBorderColor);
  overflow: hidden;

  /* SLIDER */
  .slider {
    position: absolute;
		top: 2px;
    left: 4px;
    height: calc(100% - 4px);
    width: 54px;
    // width: calc(100% / 2);

    background: var(--primary);
    border-radius: 999px;
    transition: transform 0.3s ease;

    transform: translateX(calc(var(--index, 0) * 100%));
  }
	&[data-disabled='true'] .slider {
		opacity: 0.7;
	}	

  .check-control {
    position: relative;
    z-index: 2;
    flex: 1;
    display: flex;
    justify-content: center;
    cursor: pointer;
		text-align:center;
  }

  .check-control input {
    display: none;
  }

  .check-mark {
    padding: 2px 4px;
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    color: var(--subHeadingColor);
    border-radius: 999px;
    transition: color 0.25s ease;
		min-width: 54px;
  }

  /* ACTIVE TEXT */
  .check-control input:checked + .check-mark {
    color: #fff;
  }

  /* DISABLED */
  .check-control input:disabled + .check-mark {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;